import { NgModule } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';
import {
	CommonModule,
	CurrencyPipe,
	DatePipe,
	DecimalPipe,
	APP_BASE_HREF,
	Location,
	LocationStrategy,
	PathLocationStrategy
} from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, UrlHandlingStrategy, UrlTree } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragulaModule } from 'ng2-dragula';
import { ImageCropperComponent } from 'ngx-img-cropper';
import { MyDatePickerModule } from 'mydatepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { TextMaskModule } from 'angular2-text-mask';
import { QuillModule } from 'ngx-quill';
import { NgbActiveModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ClipboardModule } from 'ngx-clipboard';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { IframeResizerDirective } from '@web-directives/iframe-resizer/iframe-resizer.directive';
import { TimeFilterPipe } from '@pipes/time-filter/time-filter';
import { CutStringFilterPipe } from '@pipes/cut-string/cut-string';
import { BoldPipeFilter } from '@pipes/bold/boldPipe';
import { AmountValidationDirective } from '@web-directives/AmountValidation/amountValidation.directive';
import { ElemToScrollDirective } from '@web-directives/ElemToScroll/elemToScroll.directive';
import { SnDatePickerValidatorDirective } from '@web-directives/sn-date-picker-validator/sn-date-picker-validator.directive';
import { SnDateRangePickerDirective } from '@web-components/common/sn-date-range-picker/sn-date-range-picker.directive';
import { SpinningWheelComponent } from '@components/common/spinning-wheel/spinning-wheel';
import { downgradedComponents } from '@web-components/modernComponents';
import { PipesModule } from '@pipes/pipes.module';
import { WebServicesModule } from '@web-services/services.module';
import { AppConstants } from '@models/appConstants';
import { TwoFactorAuthorizationInterceptor } from '@web-interceptors/twoFa.interceptor';
import { BrowserSessionTokenInterceptor } from '@web-interceptors/browserSessionToken.interceptor';
import { WebRequestsInterceptor } from '@web-interceptors/webRequestsInterceptor';
import { AppComponent } from './app.component';
import '../shared/rxjs-operators';
import { BlobErrorInterceptor } from '../shared/interceptors/blobError.interceptor';
import { LeadSourceColorComponent } from '@components/common/lead-source-color/lead-source-color';
import { SharedDirectivesModule } from '@directives/directives.module';
// Please see NgSelectModule file for detailed description of why library is sitting inside the project, and not hosted by npm
import { NgSelectModule } from '@libs/@ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { SystemNotificationInterceptor } from '@web-interceptors/systemNotification.interceptor';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

const pipes = [
	DatePipe,
	CurrencyPipe,
	DecimalPipe,
	TimeFilterPipe,
	BoldPipeFilter,
	CutStringFilterPipe
];

const snDirectives = [
	AmountValidationDirective,
	SnDatePickerValidatorDirective,
	SnDateRangePickerDirective,
	SpinningWheelComponent,
	IframeResizerDirective,
	ElemToScrollDirective
];

class HybridUrlHandlingStrategy implements UrlHandlingStrategy {
	// use only process the `/bar` url
	shouldProcessUrl(url: UrlTree) {
		return url.toString().startsWith('/bar');
	}

	extract(url: UrlTree) {
		return url;
	}

	merge(url: UrlTree, whole: UrlTree) {
		return url;
	}
}

@NgModule({
	imports: [
		CommonModule,
		BrowserModule,
		UpgradeModule,
		HttpClientModule,
		FormsModule,
		PipesModule,
		SharedDirectivesModule,
		MyDatePickerModule,
		ReactiveFormsModule,
		DragulaModule,
		NgxDaterangepickerMd,
		TextMaskModule,
		NgbModalModule.forRoot(),
		QuillModule.forRoot(),
		WebServicesModule.forRoot(),
		BsDropdownModule.forRoot(),
		RouterModule.forRoot([], {}),
		ClipboardModule,
		NgxDropzoneModule,
		NgxPaginationModule,
		CarouselModule.forRoot(),
		AngularMultiSelectModule,
		// Please see NgSelectModule file for detailed description of why library is sitting inside the project, and not hosted by npm
		NgSelectModule
		// RouterModule.forRoot([], { initialNavigation: false }),
	],
	providers: [
		...pipes,
		Location,
		NgbActiveModal,
		{ provide: LocationStrategy, useClass: PathLocationStrategy },
		{ provide: UrlHandlingStrategy, useClass: HybridUrlHandlingStrategy },
		{
			provide: APP_BASE_HREF,
			useValue:
				AppConstants.IS_PROD_BUILD || AppConstants.IS_TEST_BUILD
					? window['_app_base']
					: '/'
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: WebRequestsInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: BrowserSessionTokenInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: SystemNotificationInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TwoFactorAuthorizationInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: BlobErrorInterceptor,
			multi: true
		},
		{
			provide: '$routeParams',
			useFactory: ($injector: any) => $injector.get('$routeParams'),
			deps: ['$injector']
		},
		{
			provide: '$rootScope',
			useFactory: ($injector: any) => $injector.get('$rootScope'),
			deps: ['$injector']
		}
	],
	declarations: [
		AppComponent,
		ImageCropperComponent,
		...snDirectives,
		...downgradedComponents
	],
	entryComponents: [...downgradedComponents],
	exports: [LeadSourceColorComponent],
	bootstrap: [AppComponent]
})
export class AppModule {
	ngDoBootstrap() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/app.module.ts